import { ContractBudgetDetail } from './contract-budget-detail';
import { ContractPerformanceBreakdownDataPoints } from './contract-performance-breakdown-data-points';
import { ContractPerformanceBudget } from './contract-performance-budget';
import { ContractPerformanceMarketBreakdownDataPoints } from './contract-performance-market-breakdown-data-points';
import { ContractPerformanceSavingsBreakdown } from './contract-performance-savings-breakdown';
import { ContractUsage } from './contract-usage';

export class ContractPerformance {
	public contractRate: number;
	public utilityRates: { rate: number; date: Date }[];
	public utilitySavings: number;
	public marketSavings: number;
	public previousContractSavings: number;
	public contractUsages: ContractUsage[];
	public contractUsageOverrides: ContractUsage[];
	public contractBudgetDetail: ContractBudgetDetail;
	public hasUtilityRates: boolean;
	public hasMarketRates: boolean;
	public marketBreakdownPriceDataPoints: ContractPerformanceMarketBreakdownDataPoints[];
	public breakdownPriceDataPoints: ContractPerformanceBreakdownDataPoints[];
	public savingsBreakdown: ContractPerformanceSavingsBreakdown[];
	public budget: ContractPerformanceBudget[];

	constructor(contractPerformance?: ContractPerformance) {
		Object.assign(this, contractPerformance);

		this.contractUsages = this.contractUsages ? this.contractUsages.map(u => new ContractUsage(u)) : this.contractUsages;
		this.contractUsageOverrides = this.contractUsageOverrides
			? this.contractUsageOverrides.map(u => new ContractUsage(u))
			: this.contractUsageOverrides;
		this.marketBreakdownPriceDataPoints = this.marketBreakdownPriceDataPoints
			? this.marketBreakdownPriceDataPoints.map(u => new ContractPerformanceMarketBreakdownDataPoints(u))
			: this.marketBreakdownPriceDataPoints;
		this.breakdownPriceDataPoints = this.breakdownPriceDataPoints
			? this.breakdownPriceDataPoints.map(u => new ContractPerformanceBreakdownDataPoints(u))
			: this.breakdownPriceDataPoints;
		this.savingsBreakdown = this.savingsBreakdown
			? this.savingsBreakdown.map(u => new ContractPerformanceSavingsBreakdown(u))
			: this.savingsBreakdown;
		this.budget = this.budget ? this.budget.map(u => new ContractPerformanceBudget(u)) : this.budget;
	}
}
